import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  brand: [],
  model: [],
  spare: [],
};

const masterSpareFilterSlice = createSlice({
  name: "masterSpareFilter",
  initialState,
  reducers: {
    // Set multiple filters at once (merge with current state)
    setFilterOption(state, action) {
      Object.entries(action.payload).forEach(([key, value]) => {
        if (!(key in state)) return; // Skip unknown keys

        // Null/undefined resets to initial value
        if (value === null || value === undefined) {
          state[key] = initialState[key];
        } else {
          state[key] = value; // Keep empty arrays as-is for multi-select filters
        }
      });
    },

    // Set a single filter
    setSingleFilter(state, action) {
      const { key, value } = action.payload;
      if (!(key in state)) return;

      state[key] = value === null || value === undefined ? initialState[key] : value;
    },

    // Remove a specific value from multi-select filters or reset single-value filters
    removeFilterValue(state, action) {
      const { key, value } = action.payload;
      if (!(key in state)) return;

      if (Array.isArray(state[key])) {
        state[key] = state[key].filter((v) => v !== value);
      } else {
        state[key] = initialState[key];
      }
    },

    // Reset all filters
    resetFilter() {
      return { ...initialState };
    },
  },
});

export const {
  setFilterOption,
  setSingleFilter,
  removeFilterValue,
  resetFilter,
} = masterSpareFilterSlice.actions;

// Selector
export const selectMasterSpareFilter = (state) => state.masterSpareFilter;

export default masterSpareFilterSlice.reducer;
